export default "__VITE_ASSET__4R$yK6cg__"